export default "__VITE_ASSET__IEwDr4AY__"